<div id="ngx-datatable" class="page-layout simple fullwidth" perfect-scrollbar>
  <!-- HEADER -->
  <!-- <div class="header mat-accent-bg p-12 p-sm-24 thinHeader" fxLayout="column" fxLayoutAlign="start start"
    fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
    <div fxFlex="" fxLayoutAlign="start center">
      <mat-icon class="logo-icon" *eguardIfOnDom>assignment</mat-icon>&nbsp;&nbsp;
      <span class="logo-text h1">Cases </span>
    </div>
  </div> -->

  <!-- / HEADER -->
  <!-- CONTENT -->
  <mat-progress-bar *ngIf="openCasesLoading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <div class="content p-24">
    <div class="table-header">
      <mat-form-field style="padding: 10px 20px 0px;">
        <input matInput type="text" [(ngModel)]="inputValue" (keyup)="applyFilter($event.target.value)" placeholder="Search">
        <mat-icon matPrefix>search</mat-icon>
        <mat-icon *ngIf="inputValue.length > 1" matSuffix (click)="inputValue=''" style="cursor: pointer;">close</mat-icon>
      </mat-form-field>
    </div>
    <mat-table [dataSource]="cases" matSort (matSortChange)="sortData($event)">
      <ng-container matColumnDef="caseNo">
        <mat-header-cell *matHeaderCellDef mat-sort-header="CaseNumber"> Case Number </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-button color="accent" (click)="openCase(element.id)" style="margin-left: -16px">
            {{element.summary.case_number || element.ward.name}}
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{getStatusText(element.id)}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="creationDate">
        <mat-header-cell *matHeaderCellDef  mat-sort-header="creationDate"> Creation Date </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.summary.created_date | date}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="modifiedDate">
        <mat-header-cell *matHeaderCellDef  mat-sort-header="modifiedDate"> Modified Date </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.summary.modified_date | date}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createdBy">
        <mat-header-cell *matHeaderCellDef> Created By </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{userNames[element.summary.created_by] }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="modifyBy">
        <mat-header-cell *matHeaderCellDef> Modified By </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{userNames[element.summary.modified_by]}}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator [pageSize]="15" [pageSizeOptions]="[15, 30, 50]" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/cases/clerk-cases.component.html